import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../../features/auth/authSlice';
import RoleBasedWelcomeMessage from './RoleBasedWelcomeMessage';

const WelcomeSection = () => {
  const user = useSelector(selectCurrentUser);

  // Memoize formatted date to prevent re-calculation on every render
  const formattedDate = useMemo(() => {
    return new Date().toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    }).toUpperCase();
  }, []); // Empty dependency array - only calculate once per day would be ideal, but once per mount is acceptable

  // Memoize username display to prevent unnecessary re-renders
  const displayName = useMemo(() => {
    return user?.username || 'User';
  }, [user?.username]);

  return (
    <div 
      className="bg-crystal-white border border-silver-mist shadow-lg overflow-hidden"
      style={{ borderRadius: '24px' }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8 lg:py-12">
        <div className="space-y-6">
          <RoleBasedWelcomeMessage />
          
          <div 
            className="flex flex-col sm:flex-row sm:items-center sm:justify-between pt-6 border-t border-silver-mist/30 bg-silver-mist/30 px-6 py-4 -mx-6"
            style={{ borderRadius: '16px' }}
          >
            <div className="space-y-1">
              <p className="text-sm font-display font-semibold uppercase tracking-wider text-steel opacity-75">
                ACTIVE SESSION
              </p>
              <p className="text-charcoal-gray font-display font-medium">
                <span className="text-slate-gray">Welcome back,</span>{' '}
                <span className="text-deep-jungle font-display font-bold">{displayName}</span>
              </p>
            </div>
            
            <div className="mt-4 sm:mt-0 flex items-center space-x-6 text-sm">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-fresh-leaf"></div>
                <span className="text-steel font-display font-semibold">SYSTEM ONLINE</span>
              </div>
              <div className="h-4 w-px bg-steel opacity-20"></div>
              <span className="text-steel font-display font-medium">
                {formattedDate}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(WelcomeSection);
